import React from 'react';
import { Input } from 'antd';

import { OptionItem } from '../../types';

import './index.less';

interface IProps {
  firstIndex: number;
  secondIndex: number;
  options: OptionItem[];
  myAnswer: string | string[];
  fillAnswer: (firstIndex: number, secondIndex: number, options: OptionItem[], isSubmit: boolean) => void;
}

function CompletionOption({ firstIndex, secondIndex, myAnswer, options, fillAnswer }: IProps) {

  function changeInputValue(e: React.ChangeEvent<HTMLInputElement>, index: number) {
    console.log(e);
    let newOptions = [...options];
    newOptions[index].blankAnswer = e.target.value;
    fillAnswer(firstIndex, secondIndex, newOptions, false);
  }

  function onBlur() {
    fillAnswer(firstIndex, secondIndex, options, true);
  }

  return (
    <div className="test-completion-option">
      <ul className="ul">
        {
          options.map((item, index) => {
            return (
              <li key={index}>
                <div className="number">{index + 1}</div>
                <Input value={item.blankAnswer} onBlur={onBlur} onChange={(e) => changeInputValue(e, index)} placeholder="请输入选项" />
              </li>
            )
          })
        }
      </ul>

    </div>
  )
}

export default CompletionOption;

